import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Doughnut} from 'react-chartjs-2';
import {
    PageHeader,
    ListGroup,
    ListGroupItem,
    Col,
    Panel,
    Button,
    Jumbotron,
    Glyphicon
} from 'react-bootstrap';
import config from '../config.js';
import { invokeApig } from '../libs/awsLib';
import CustomListGroupItem from '../components/CustomListGroupItem';
import './Home.css';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
        isLoading: false,
        customers: [],
        chart: {
            labels: [
                'Running Reports',
                'Running Imports',
                'Number of Customers'
            ],
            datasets: [{
                data: [0, 0, 0],
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }]
        }
    };
  }
  
    async componentDidMount() {
      if (! this.props.auth.isUserSignedIn()) {
        console.log("Home.js token: no token");
        return;
      }
      this.setState({ isLoading: true });
      var customers = await this.customers();
      this.setState({ customers: customers});
      this.setTasksChart(customers);
      this.setState({ isLoading: false });
    }

    async setTasksChart(customers){
        try {
          const results = await this.tasks();
          var allCustomers = customers.length;
          var allImports = 0;
          var allReports = 0;
          [{}].concat(results).map((task, i) => {
            if(i !== 0) {
              if (((task.taskStatus === "running")||(task.taskStatus === "generic")) && ((task.taskType === "create_customer")||(task.taskType === "create_import")||(task.taskType === "run_indexing"))){
                  allImports += 1;
              }

              if (((task.taskStatus === "running")||(task.taskStatus === "generic")) && (task.taskType === "create_report")){
                  allReports += 1;
              }
            }
            return true;
          })

          var chart = this.state.chart;
          chart.datasets[0].data = [allReports, allImports, allCustomers];
          this.setState({ chart: chart });
        }
        catch(e) {
          console.log(e);
          alert("Error querying customer data. Try refreshing the page.");
        }
    }

    async customers() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: '/customers' },  token);
    }

    async tasks() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: '/customers/tasks' }, token);
    }

    async deleteCustomer(customerId) {
      var token = await this.props.getUserToken();
      return invokeApig({
          path: `/customers/${customerId}`,
          method: 'DELETE',
      }, token);
    }

    handleDeleteCustomer = async (customerId, customerIndex, event) => {
        event.preventDefault();
        event.stopPropagation();

        const confirmed = window.confirm('Are you sure you want to delete "' + customerIndex+ '" customer?\n\n' +
          'This action cannot be undone and will delete all data permanently!');

        if ( ! confirmed) {
            return;
        }

        try {
          await this.deleteCustomer(customerId);
          var customers = await this.customers();
          this.setState({ customers: customers});
          await this.setTasksChart(this.state.customers);
        }
        catch(e) {
            alert(e);
        }
    }

    handleCustomerClick = (event) => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute('href'));
    }

    handleLoginClick = (event) => {
        event.preventDefault();
        try {
            this.props.auth.getSession();

        }
        catch(e) {
            alert(e);
        }
    }

  renderLander() {
    return ! this.props.isLoadingUserToken
      && (
        <div className="lander">
          {/*<img src={'/data-analytics-608x211.jpg'} alt="" className="img-responsive"/>*/}
            <Jumbotron>
                <h1>Welcome to OAS Portal!</h1>
                <p>
                    Riverbed OAS is a cloud analytics platform available to Riverbed's employees and partners.
                </p><p>

                    Riverbed OAS processes your NPM/APM data, device syslogs and other data in real time
                    to provide a holistic and in-depth view of your entire network infrastructure.
                </p><p>
                    OAS offers network failure and anomaly detection powered by Machine Learning.
                </p>
                <p>
                    <Button href="/login/sso">Log In</Button>
                </p>
            </Jumbotron>

            <video id="video-background" muted loop autoPlay>
                <source src="/BG-network.mp4" type="video/mp4"/>
            </video>


            <div className="content">
                <Col xs={12} md={12}>
                    <h1>
                        Unlock the power of your data
                    </h1>
                </Col>
                <Col xs={12} md={4}>
                    {/*<Panel onClick={(event) =>{event.preventDefault(); this.props.history.push("/Customers");}}>*/}
                    <Panel>
                      <Panel.Body>
                        <h3><Glyphicon glyph="eye-open" /></h3>
                        <h3>Drive cutomer insights</h3>
                        <p>
                            Understanding exactly where you need to go is critical in executing flawlessly.
                        </p>
                        <small>Learn more <Glyphicon glyph="chevron-right" /></small>
                      </Panel.Body>
                    </Panel>
                </Col>
                <Col xs={12} md={4}>
                    <Panel>
                      <Panel.Body>
                        <h3><Glyphicon glyph="globe" /></h3>
                        <h3>Increase visibility</h3>
                        <p>
                            Understanding exactly where you need to go is critical in executing flawlessly.
                        </p>
                        <small>Learn more <Glyphicon glyph="chevron-right" /></small>
                      </Panel.Body>
                    </Panel>
                </Col>
                <Col xs={12} md={4}>
                    <Panel bsStyle="info">
                      <Panel.Body>
                        <h3><Glyphicon glyph="thumbs-up" /></h3>
                        <h3>Protect your business</h3>
                        <p>
                            Security - Risk - Compliance. Keep your business risk low and security high.
                        </p>
                        <small>Learn more <Glyphicon glyph="chevron-right" /></small>
                      </Panel.Body>
                    </Panel>
                </Col>
            </div>

        </div>
    );
  }
  
  renderCustomers() {
    return (
      <div className="customers">
        <PageHeader>OAS Home</PageHeader>
          { ! this.state.isLoading
            && this.renderCustomersList(this.state.customers) }
      </div>
    );
  }
  
  render() {
    return (
      <div className="Home">
        { this.props.auth.isUserSignedIn()
          ? this.renderCustomers()
          : this.renderLander() }
      </div>
    );
  }
  
  renderCustomersList(customers) {
      return(
          <div className="Customers">
              <Col xs={16} md={8} >
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title componentClass="h2">Your Customer List</Panel.Title>
                    </Panel.Heading>
                    <ListGroup>
                  {
                      //console.log(JSON.stringify(customers));
                         [{}].concat(customers).map((customer, i) => (
                          i !== 0
                            ? ( <CustomListGroupItem
                                    key={customer.customerId}
                                    href={`/customers/${customer.customerId}`}
                                    onClick={this.handleCustomerClick}
                                    leftImage="/user-4-32-b.png"
                                    Title={customer.customerIndex}
                                    createdDate={(new Date(customer.createdAt)).toLocaleString()}
                                    titleCustom="Splunk"
                                    handleCustom={(evt) => {evt.preventDefault(); evt.stopPropagation(); window.open(`${config.externalURL.splunkURL}/${customer.customerId}`, "_blank");}}
                                    handleDelete={(evt) => this.handleDeleteCustomer(customer.customerId, customer.customerIndex, evt)}
                                /> )
                            : ( <ListGroupItem
                                  key="new"
                                  href="/customers/new"
                                  onClick={this.handlecustomerClick}>
                                    <h4><b>{'\uFF0B'}</b> Create a new customer</h4>
                                </ListGroupItem> )
                        ))
                  }
                    </ListGroup>
                  </Panel>
              </Col>
              <Col xs={16} md={4} >
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title componentClass="h2">Overall Status</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <div>
                          <Doughnut
                              height={250}
                              data={this.state.chart}
                              options={{tooltips: {intersect: false}}}/>
                      </div>
                    </Panel.Body>
                  </Panel>
              </Col>
          </div>
      )

  }

}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/containers/Home.js